import { UserSelectableEntityResponseDto } from "./users";
import { Paginated } from "./utils";

export enum SaleState {
  Draft = "DRAFT",
  Open = "OPEN",
  Completed = "COMPLETED",
  Closed = "CLOSED",
  Cancelled = "CANCELLED",
  Lost = "LOST",
}

export interface CreateSaleRequestDto {
  title: string;
  ownLead: boolean;
  belongsToDealId: string;
}

export interface UpdateSaleRequestDto {
  title?: string;
  ownLead?: boolean;
}

export interface SaleListResponseDto {
  _id: string;
  title: string;
  totalNetPrice: number;
  totalGrossPrice: number;
  state: SaleState;
  createdAt: string;
  belongsToUserFullName: string;
}

export interface SaleListPaginatedResponseDtoWithSelectableEntities {
  sales: Paginated<SaleListResponseDto>;
  selectableEntities: SaleSelectableEntitiesResponseDto;
}

export interface SaleSelectableEntitiesResponseDto {
  users: UserSelectableEntityResponseDto[];
}

export interface DealPreviewResponseDto {
  _id: string;
  title: string;
  isArchived: boolean;
  isWon: boolean;
  pipelineTitle: string;
}

export interface SaleDetailsResponseDto {
  _id: string;
  title: string;
  belongsToUserId?: string;
  totalNetPrice: number;
  totalGrossPrice: number;
  ownLead: boolean;
  state: SaleState;
  completedAt?: string;
  createdAt: string;
  updatedAt: string;
  products: ProductLineItemDetailsResponseDto[];
  isEditable: boolean;
  statusOpenPossible: boolean;
  statusCompletedPossible: boolean;
  statusCancelledPossible: boolean;
  provisions: ProvisionResponseDto[];
  dealsPreview: DealPreviewResponseDto;
  belongsToUserFullName: string;
}

export interface ProductLineItemDetailsResponseDto {
  _id: string;
  title: string;
  productNetPrice: number;
  productGrossPrice: number;
  productNetInstallationCost: number;
  productGrossInstallationCost: number;
  netPrice: number;
  grossPrice: number;
  amount: number;
  totalNetPrice: number;
  totalGrossPrice: number;
  isBasicSecurity: boolean;
}

export interface ProvisionResponseDto {
  _id: string;
  belongsToUserId: string;
  belongsToUserFullName: string;
  belongsToSaleId: string;
  belongsToSalesRankTitle?: string | undefined;
  belongsToProductId: string;
  productTitle: string;
  productNetPrice: number;
  netPrice: number;
  productNetInstallationCost: number;
  amount: number;
  totalNetPrice: number;
  provisionBase: number;
  provisionPercentage: number;
  provisionAmount: number;
  ownLeadProvision?: number;
  leadCost?: number;
  saleLossDifference?: number;
  saleWinDifference?: number;
  totalProvisionAmount: number;
  isBasicSecurity: boolean;
  provisionBonusCalculationsEditable: boolean;
}

export interface CreateProductLineItemRequestDto {
  belongsToProductId: string;
}

export interface UpdateProductLineItemRequestDto {
  netPrice?: number;
  amount?: number;
}

export interface UpdateProvisionRequestDto {
  provisionPercentage?: number;
  ownLeadProvision?: number;
  leadCost?: number;
}

export interface SalePreviewResponseDto {
  _id: string;
  title: string;
  state: SaleState;
  totalNetPrice: number;
  totalGrossPrice: number;
  products: ProductLineItemDetailsResponseDto[];
  isViewable: boolean;
}
